<template>
    <CodiceFeanorView tool-module="byte" />
</template>

<script setup>
import CodiceFeanorView from "../CodiceFeanorView.vue";
</script>
